import { Observable, of, Subject, fromEvent, merge } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSession } from '../objects/Session';
import { catchError, mapTo } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TokenManager } from '../Globals';
import { Globals } from '../objects/Globals';
import { ToasterService, BodyOutputType } from 'angular2-toaster';
import { Toaster } from '../objects/ToasterObject';
import { ToasterMessageService } from './toaster-message.service';
import { BsModalService } from '../../../node_modules/ngx-bootstrap';
import { EnvService } from '../env.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
import * as i3 from "../Globals";
import * as i4 from "ngx-bootstrap/modal";
import * as i5 from "../objects/Globals";
import * as i6 from "angular2-toaster/src/toaster.service";
import * as i7 from "./toaster-message.service";
import * as i8 from "../env.service";
var httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true' })
};
var LoginService = /** @class */ (function () {
    function LoginService(http, router, tokenManager, bsModalService, globals, toasterService, toasterMessageService, env) {
        this.http = http;
        this.router = router;
        this.tokenManager = tokenManager;
        this.bsModalService = bsModalService;
        this.globals = globals;
        this.toasterMessageService = toasterMessageService;
        this.env = env;
        this.session = new Subject();
        this.defaultId = '00000000-0000-0000-0000-000000000000';
        this.isMobile = new Subject();
        this.isMobileChanged$ = this.isMobile.asObservable();
        this.loggedIn$ = this.session.asObservable();
        this.loginUrl = this.env.servicePath;
        this.toasterService = toasterService;
        this.online$ = merge(of(navigator.onLine), fromEvent(window, 'online').pipe(mapTo(true)), fromEvent(window, 'offline').pipe(mapTo(false)));
    }
    LoginService.prototype.setDeviceInfo = function (isMobile) {
        this.isMobile.next(isMobile);
    };
    LoginService.prototype.login = function (loginCredentials) {
        var httpOption = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true' })
        };
        return this.http.post(this.loginUrl + "StartSession", loginCredentials, httpOption).pipe(catchError(this.handleError('login', null)));
    };
    LoginService.prototype.proceed = function (holdId, isProceed, param) {
        var path = this.loginUrl + "ProceedLogin/" + holdId + "/" + isProceed;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true' })
        };
        return this.http.post("" + path, param, httpOptions);
    };
    LoginService.prototype.getSessionKey = function () {
        var path = this.loginUrl + "GenerateSessionContinueKey";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    LoginService.prototype.continueSession = function (username, password, sessionId) {
        var self = this;
        return this.http.post(this.loginUrl + "ContinueSession/" + username + "/" + password + "/" + sessionId, "", httpOptions).pipe(catchError(this.handleError('login', null)));
    };
    LoginService.prototype.getSession = function (sessionId) {
        var self = this;
        return this.http.get(this.loginUrl + "GetSession/" + sessionId, httpOptions);
    };
    LoginService.prototype.setSession = function (session) {
        this.session.next(session);
    };
    LoginService.prototype.getHomePage = function () {
        var path = this.loginUrl + "GetHomePage";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    LoginService.prototype.goHome = function () {
        var path = this.loginUrl + "GoHome";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    LoginService.prototype.resendVerificationEmail = function (param) {
        var path = this.loginUrl + "ResendVerificationEmail";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.defaultId, "Session": this.defaultId })
        };
        return this.http.post("" + path, param, httpOptions);
    };
    LoginService.prototype.forgotLoginDetails = function (param) {
        var path = this.loginUrl + "ForgotLoginDetails";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.defaultId, "Session": this.defaultId })
        };
        return this.http.post("" + path, param, httpOptions);
    };
    LoginService.prototype.resetPassword = function (param) {
        var path = this.loginUrl + "ResetPassword";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.defaultId, "Session": this.defaultId })
        };
        return this.http.post("" + path, param, httpOptions);
    };
    LoginService.prototype.validatePassword = function (param) {
        var path = this.loginUrl + "ValidatePassword";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.defaultId, "Session": this.defaultId })
        };
        return this.http.post("" + path, param, httpOptions);
    };
    LoginService.prototype.log = function (message) {
        console.log("LoginService: " + message);
    };
    LoginService.prototype.handleError = function (operation, result) {
        var _this = this;
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            // TODO: send the error to remote logging infrastructure
            console.log(error); // log to console instead
            _this.setSession(null);
            if (error.status == 400) {
                _this.popToast("Connection is lost", "There seems to be a problem connecting to the server, please contact system administrator accordingly", "warning");
                setTimeout(function () {
                    //this.clear();
                    //this.router.navigate(['/login']); 
                }, 4000);
            }
            else {
                _this.popToast("Error", "Unable to connect to the service", "error");
                //this.clear();
                //this.router.navigate(['/login']);
            }
            // TODO: better job of transforming error for user consumption
            _this.log(operation + " failed: " + error.message);
            // Let the app keep running by returning an empty result.
            return of(result);
        };
    };
    LoginService.prototype.clear = function () {
        this.globals.Session = null;
        this.session.next();
        this.bsModalService.hide(1);
        document.body.classList.remove('modal-open');
        this.tokenManager.clear();
        this.toasterMessageService.clearToaster();
    };
    LoginService.prototype.popToast = function (title, body, type) {
        var _this = this;
        var toast = {
            type: type,
            title: title,
            body: body,
            showCloseButton: true,
            bodyOutputType: BodyOutputType.TrustedHtml,
            onShowCallback: function (toast) {
                var toaster = new Toaster();
                toaster.id = toast.toastId;
                toaster.timestamp = Date.now();
                toaster.title = toast.title;
                toaster.content = toast.body;
                _this.toasterMessageService.pushToaster(toaster);
            }
        };
        var toasterObj = this.toasterMessageService.getToaster();
        if (toasterObj.length > 0) {
            if (toasterObj.slice(-1).pop().title != 'Connection is lost') {
                this.toasterService.pop(toast);
            }
        }
        else {
            this.toasterService.pop(toast);
        }
    };
    LoginService.ngInjectableDef = i0.defineInjectable({ factory: function LoginService_Factory() { return new LoginService(i0.inject(i1.HttpClient), i0.inject(i2.Router), i0.inject(i3.TokenManager), i0.inject(i4.BsModalService), i0.inject(i5.Globals), i0.inject(i6.ToasterService), i0.inject(i7.ToasterMessageService), i0.inject(i8.EnvService)); }, token: LoginService, providedIn: "root" });
    return LoginService;
}());
export { LoginService };
